/* gsap.registerPlugin(ScrollTrigger);

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);
import { ScrollToPlugin } from "gsap/all"; */



import homeAnim from "./home";


let homepage = document.querySelector("#home");
if (homepage !== null) {
  homeAnim.init();
}


